// extracted by mini-css-extract-plugin
export var calendarView = "_l1-0";